<template>
  <Html>
    <Head>
      <Title>CMS | Ellie</Title>
    </Head>

    <Body>
      <NuxtLoadingIndicator :color="'#fed400'" :height="4" />

      <div :data-theme="theme" class="flex min-h-screen">
        <div :class="[{ 'w-72':!collapseSidebar, 'w-12': collapseSidebar }]" class="flex-shrink-0">
        </div>
        <div class="bg-gray-50 flex-grow p-6 overflow-y-hidden">
          <NuxtPage />
        </div>
      </div>
      <div id="admin-sidebar" :class="[{ 'w-72':!collapseSidebar, 'w-12': collapseSidebar }]" class="fixed left-0 top-0 h-full bg-white transition-all overflow-y-auto overflow-x-hidden z-10">
        <AdminSidebar />
      </div>
    </Body>
  </Html>
</template>

<script setup>
const THEMES = [
  'light',
  'dark',
];
const theme = ref('light');
const sidebarStore = useAdminSidebarStore();
const collapseSidebar = computed(() => sidebarStore.$state.collapseSidebar);
watch(theme, (value) => {
  localStorage.setItem('daisyui-theme', value);
});
const isLoading = ref(true);
const ready = ref(false);
watch(theme, (value) => {
  localStorage.setItem('daisyui-theme', value);
});
onMounted(() => {
  theme.value = 'light';
});
</script>

<style type="text/scss">
  @import url("~/assets/scss/admin.scss");
  body{
    font-family: 'Inter', sans-serif !important;
  }
  #admin-sidebar {
      -ms-overflow-style: none;  /* Internet Explorer 10+ */
      scrollbar-width: none;  /* Firefox */
  }
  #admin-sidebar::-webkit-scrollbar {
      display: none;  /* Safari and Chrome */
  }
</style>
